import { object, string } from 'yup'
import {
  Building2,
  Files,
  FileText,
  Folders,
  Network,
  Pyramid,
  ReceiptText,
  User,
  UserPlus,
  Users,
  Wallet,
} from 'lucide-vue-next'
import type { AppConfig } from '~/../genesis/types/app'
import { AdditionalFormsFields } from '~/../genesis/constants/components/additional'
import { OrganizationRoles } from '~/../genesis/constants/organizations'
import { AppRoles } from '~/../genesis/constants/user'
import { EntityTypes } from '~/constants/entity'
import { AdminRoutes, OrganizationRoutes } from '~/constants/routes'

export default defineAppConfig({
  disableSignUp: true,
  minimumRoleToCreateOrganization: AppRoles.Admin,
  minimumRoleToCreateWorkspace: OrganizationRoles.Admin,
  menuItems: {
    app: {
      [OrganizationRoles.Viewer]: [
        {
          label: 'Mon compte',
          items: [
            {
              label: 'Profil',
              icon: User,
              to: OrganizationRoutes.Account.Profile,
            },
            {
              label: 'Mon réseau',
              icon: Network,
              to: OrganizationRoutes.Account.Network,
            },
            {
              label: 'Commissions',
              icon: Wallet,
              to: OrganizationRoutes.Account.Commissions.Base,
            },
            {
              label: 'Bordereaux',
              icon: FileText,
              to: OrganizationRoutes.Account.Slips.Base,
            },
            {
              label: 'Mes entités',
              icon: Building2,
              to: OrganizationRoutes.Account.Entities,
            },
          ],
        },
      ],
      [OrganizationRoles.Admin]: [
        {
          label: 'Membres',
          items: [
            {
              label: 'Ajouter un membre',
              icon: UserPlus,
              to: OrganizationRoutes.Corporate.CreateMember.Base,
            },
            {
              label: 'Membres & invitations',
              icon: Users,
              to: OrganizationRoutes.Corporate.Members.Base,
            },
          ],
        },
        {
          label: 'Commissions',
          items: [
            {
              label: 'Toutes les commissions',
              icon: ReceiptText,
              to: OrganizationRoutes.Corporate.Commissions.Base,
            },
          ],
        },
        {
          label: 'Dossiers',
          items: [
            {
              label: 'Tous les dossiers',
              icon: Folders,
              to: OrganizationRoutes.Corporate.Cases.Base,
            },
          ],
        },
        {
          label: 'Entités',
          items: [
            {
              label: 'Toutes les entités',
              icon: Building2,
              to: OrganizationRoutes.Corporate.Entities.Base,
            },
            {
              label: 'Tous les bordereaux',
              icon: Files,
              to: OrganizationRoutes.Corporate.Slips.Base,
            },
          ],
        },
      ],
    },
    admin: {
      [AppRoles.Admin]: [
        {
          label: 'App settings',
          items: [
            {
              label: 'Paramètres MLM',
              icon: Pyramid,
              to: AdminRoutes.MLMParameters,
            },
            {
              label: 'Création utilisateurs',
              icon: Users,
              to: AdminRoutes.UsersBatch,
            },
          ],
        },
      ],
    },
  },
  additionalFormsFieldsSchemas: {
    [AdditionalFormsFields.Workspace.CreationDialog]: object().shape({
      siret: string().min(17).required(),
      type: string().oneOf([
        EntityTypes.Billing,
        EntityTypes.MLMBilling,
      ]).required(),
      address: string().required(),
      description: string().optional(),
    }),
  },
} as AppConfig)
